import { createContext, useContext } from 'react';

export type ContractsTableContextType = {
  activeIndex?: number;
  setActiveIndex?: Function;
};

export const ContractsTableContext = createContext<ContractsTableContextType | undefined>(undefined);

export const useContractsTableContext = (): ContractsTableContextType => useContext(ContractsTableContext);
